<template>
  <v-container>
    <v-layout>
      <v-flex xl10 lg10 md12 xs12>
        <PageHeader class="pb-2" no-padding subtitle="Customize which recipients to email and which reports to send for discrete data imports." />
        <AlertsBar :loading="loading" />

        <v-card class="mb-4">
          <v-progress-linear v-if="isLoading" class="position-sticky my-0" :height="5" color="info" indeterminate />
          <div v-else style="width: 100%; height: 5px;" />
          <Recipients :configuration="configuration" />
        </v-card>

        <v-card>
          <Guidelines :configuration="configuration" />
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import AlertsBar from './AlertsBar'
  import Recipients from './Recipients'
  import Guidelines from './Guidelines'

  import {
    PING_INTERVAL,
  } from '@/store/ServiceRegistry/services'

  export default {
    components: {
      AlertsBar,
      Recipients,
      Guidelines,
    },
    data: () => ({
      configuration: {
        recipients: [],
        guidelineStations: [],
      },
      loading: {
        configuration: true,
        service: true,
      },
      pingTimeoutId: null,
    }),
    computed: {
      isLoading() {
        return Object.values(this.loading).some(x => x)
      },
      service() {
        return this.$store.getters['importnotification/service']
      },
      isServiceActive() {
        return this.$store.getters['importnotification/isServiceActive']
      },
    },
    watch: {
      configuration: {
        deep: true,
        handler(value) {
          if (!this.isLoading) {
            this.saveConfiguration(value)
          }
        },
      },
    },
    methods: {
      pingService() {
        if (this.pingTimeoutId) return

        let ping = () => {
          this.$store.dispatch('importnotification/pingService')
        }

        ping()
        this.pingTimeoutId = setInterval(ping, PING_INTERVAL)
      },
      async saveConfiguration(configuration) {
        if (this.isLoading) {
          return
        }

        this.loading.configuration = true

        try {
          let updatedConfiguration = await this.$store.dispatch('importnotification/updateConfiguration', {
            configuration,
          })

          this.configuration = updatedConfiguration
        } catch (error) {
          this.$store.dispatch('app/setSnackbar', {
            text: 'Sorry, the notification settings could not be saved. Please reload the page in a few minutes.',
            color: 'error',
            icon: 'error',
          })
        }

        await this.$nextTick()
        this.loading.configuration = false
      },
      async fetchService() {
        this.loading.service = true
        try {
          await this.$store.dispatch('importnotification/fetchService')
          this.pingService()
        } catch (error) {
          console.error(error)
          this.$store.dispatch('app/setSnackbar', {
            text: 'Sorry, the notification settings cannot be accessed right now. Please reload the page in a few minutes.',
            color: 'error',
            icon: 'error',
          })
        }

        this.loading.service = false
      },
      async fetchConfiguration() {
        this.loading.configuration = true
        try {
          let configuration = await this.$store.dispatch('importnotification/fetchConfiguration', {})

          if (configuration) this.configuration = configuration
          else {
            console.info('There is no existing import notification configuration. A new one will be created.')
          }
        } catch (error) {
          console.error(error)
          this.$store.dispatch('app/setSnackbar', {
            text: 'Sorry, the notification settings cannot be accessed right now. Please reload the page in a few minutes.',
            color: 'error',
            icon: 'error',
          })
        }

        this.loading.configuration = false
      },
      async initialize() {
        await this.fetchService()
        if (this.service) {
          await this.fetchConfiguration()
        }
      },
    },
    created() {
      this.initialize()
    },
    beforeDestroy() {
      clearTimeout(this.pingTimeoutId)
    },
  }
</script>